export default "__VITE_ASSET__BIJ_Dqfj__"